import React, { useState } from 'react';
import { db } from '../firebase';
import { collection, query, where, getDocs } from 'firebase/firestore';
import { useNavigate } from 'react-router-dom';
import './VillageLogin.css';

export default function VillageLogin() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    
    if (!username.trim() || !password.trim()) {
      setError('Please enter both username and password');
      return;
    }

    setLoading(true);
    setError('');

    try {
      // First check if user exists in village_users collection
      const usersQuery = query(collection(db, "village_users"), where("username", "==", username.trim()));
      const userSnapshot = await getDocs(usersQuery);

      if (!userSnapshot.empty) {
        const userData = userSnapshot.docs[0].data();
        
        // Check password (in a real app, this should be hashed)
        if (userData.password === password) {
          // Store user info in localStorage for session management
          localStorage.setItem('villageUser', JSON.stringify({
            username: userData.username,
            villageCode: userData.villageCode,
            name: userData.name
          }));
          
          navigate(`/dashboard/${encodeURIComponent(userData.villageCode)}`);
        } else {
          setError('Invalid username or password');
        }
      } else {
        // Fallback to old village code system for backward compatibility
        // Check if the username is actually a village code
        const villagesQuery = query(collection(db, "villages"), where("code", "==", username.trim().toUpperCase()));
        const villageSnapshot = await getDocs(villagesQuery);

        if (!villageSnapshot.empty) {
          const villageData = villageSnapshot.docs[0].data();
          // Store village code for backward compatibility
          localStorage.setItem('villageUser', JSON.stringify({
            username: villageData.code,
            villageCode: villageData.code,
            name: villageData.name
          }));
          navigate(`/dashboard/${encodeURIComponent(villageData.code)}`);
        } else {
          // Try to find village by name as well
          const villagesByNameQuery = query(collection(db, "villages"), where("name", "==", username.trim()));
          const villageByNameSnapshot = await getDocs(villagesByNameQuery);
          
          if (!villageByNameSnapshot.empty) {
            const villageData = villageByNameSnapshot.docs[0].data();
            // Store village code for backward compatibility
            localStorage.setItem('villageUser', JSON.stringify({
              username: villageData.name,
              villageCode: villageData.code,
              name: villageData.name
            }));
            navigate(`/dashboard/${encodeURIComponent(villageData.code)}`);
          } else {
            setError('Invalid username or village code. Please check with your administrator.');
          }
        }
      }
    } catch (error) {
      console.error("Login error:", error);
      setError('Network error. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const goBack = () => {
    navigate('/');
  };

  return (
    <div className="village-login-container">
      <div className="village-login-card">
        <div className="login-header">
          <div className="logo">
            <span className="logo-icon">🐄</span>
            <h1>Village Portal</h1>
          </div>
          <p className="login-subtitle">Access your village dashboard</p>
        </div>
        
        <form onSubmit={handleLogin} className="login-form">
          <div className="form-group">
            <label htmlFor="username">Username</label>
            <input
              type="text"
              id="username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="Enter your username"
              className="form-input"
              disabled={loading}
            />
          </div>
          
          <div className="form-group">
            <label htmlFor="password">Password</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter your password"
              className="form-input"
              disabled={loading}
            />
          </div>
          
          {error && <div className="error-message">{error}</div>}
          
          <button type="submit" className="login-btn" disabled={loading}>
            {loading ? (
              <>
                <span className="spinner"></span>
                Logging in...
              </>
            ) : (
              'Login to Dashboard'
            )}
          </button>
        </form>
        
        <div className="login-footer">
          <button onClick={goBack} className="back-btn">
            ← Back to Home
          </button>
        </div>
      </div>
    </div>
  );
}
